// import './styles/RowProblem.css'
import { useState } from 'react';
import { useFetch } from '../../../hooks/useFetch';
import mapboxgl from 'mapbox-gl';
import MenuAlert from './MenuAlert';
import InternalError from '../../generales/InternalError';
const RowProblem = (props) => {
  // console.log(props.dataAgencies.data.data)
  // const [infoShow,setInfoShow]=useState({severity:0,host:"",problem:"",ip:"",ack:"",ack_message:"",time:""})
  const [menuAlertOpen, setMenuAlertOpen] = useState(false);
  const [color, setColor] = useState('#43434d');
  const [ackMessage, setAckMessage] = useState('');
  // console.log(props.data)
  const openMenuAlert = () => {
    handleSelected(props.data)
    // console.log(props.data.longitude)
    // console.log(props.ubicacion.groupid)
    // props.setUbicacion({latitud:props.data.latitude.replace(",", "."),longitud:props.data.longitude.replace(",", "."),zoom:16,groupid:props.ubicacion.groupid,dispId:props.ubicacion.dispId,templateId: props.ubicacion.templateId})
    setMenuAlertOpen(true);
  };
  const handleSelected = (element) => {}
  const closeMenuAlert = () => {

    setMenuAlertOpen(false);
  };
  function cambiarFormatoFecha(fechaEnFormatoMMDDYYYY) {
    const partes = fechaEnFormatoMMDDYYYY.split('/');
    const fechaEnFormatoYYYYMMDD = `${partes[2]}-${partes[1]}-${partes[0]}`;
    return fechaEnFormatoYYYYMMDD;
  }


  const calcularDiferenciaTiempo = (fechaDada, horaDada) => {
    // Convertir la fecha y hora dadas a objetos Date
    // const fechaHoraDadas = new Date(`${cambiarFormatoFecha(fechaDada)}T${horaDada}`);
    const fechaHoraDadas = new Date(`${fechaDada}T${horaDada}`)
    // Obtener la fecha y hora actuales
    const fechaHoraActual = new Date();
    // Calcular la diferencia en milisegundos
    const diferenciaEnMilisegundos = fechaHoraDadas - fechaHoraActual;
    // Calcular la diferencia en minutos y horas
    const minutos = Math.floor(Math.abs(diferenciaEnMilisegundos) / (1000 * 60));
    const horas = Math.floor(minutos / 60);
    const dias = Math.floor(horas / 24);
    const txtHrs = horas - (dias * 24)
    const txtMin = minutos - (horas * 60)
    const response = ((dias >= 1) ? dias + ' dias ' : '') + ((txtHrs >= 1) ? txtHrs + ' hrs ' : '') + ((txtMin >= 1) ? txtMin + ' min' : '')
    return response;
  };
  const fechaDada = '2023-17-11';//2023-05-09
  const horaDada = '12:30:20';
  // const agencys={
  //   1:'cfe.png',
  //   2:'conagua.png',
  //   3:'cfe.png',
  //   8:'manto.png',

  // }
  const agencys = {
    'cfe': 'cfe.png',
    'con': 'conagua.png',
    'imp': 'implementacion.png',
    'man': 'manto.png',

  }
  // const agencys_colors={
  //   1:'#00da19b7',
  //   2:'#00b7e1',
  //   3:'#00da19b7',
  //   8:'#c6124d',
  // }
  const agencys_colors = {
    'cfe': '#00da19b7',
    'con': '#00b7e1',
    'imp': '#777',
    'man': '#c6124d',
  }
  function getImageById(id) {
    // console.log(props.dataAgencies.data.data)
    const agency = props.dataAgencies.data.data.find(agency => agency.id === id);
    return agency ? agency.img : null;
  }
  function getColorById(id) {
    const agency = props.dataAgencies.data.data.find(agency => agency.id === id);
    return agency ? agency.color : null;
  }
  const clickRow = () => {
    if (menuAlertOpen) {
      closeMenuAlert()
    } else {
      openMenuAlert()
    }
    // closeMenuAlert:openMenuAlert
  }
  // console.log(props.data)
  try {


    return (
      <>
        {(props.data.severity != 0 && (props.data.tipo == 1 || (props.data.tipo == 0 && props.filtraOrigen == false))) ? (
          <div className={`mh-alert-row ${menuAlertOpen ? 'mh-alert-row-active' : ''}`} onClick={() => { clickRow() }}>
            <div className='mh-alert-cell' style={{ width: '6%' }}>
              <div className='mh-alert-sev'>
                {(props.data.exception_id == null || props.data.exception_id == "") ? (
                  <img src={`/iconos/alerts${props.data.severity}.svg`} className='mh-alert-sev-img' alt="Sev" />
                ) : (
                  <div style={{ border: '1px solid #e2e8f0', borderRadius: '50%', width: '22px', height: '22px', background: getColorById(props.data.exception_agency_id), display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <img src={`/iconos/${getImageById(props.data.exception_agency_id)}`} style={{ width: '12px' }} alt="Agency" />
                  </div>
                )
                }
                <span style={{ color: '#64748b' }}>S-{props.data.severity}</span>
              </div>
            </div>
            <div className='mh-alert-cell' style={{ width: '19%', fontWeight: '500' }}>
              {props.data.Problem.length > 35 ? `${props.data.Problem.slice(0, 35)}...` : ((props.data.Problem.includes("Unavailable by ICMP ping")) ? "CASSIA DESCONEXIÓN en:" : props.data.Problem)}
            </div>
            <div className='mh-alert-cell' style={{ width: '26%', color: '#475569' }}>
              {props.data.Host}
            </div>
            <div className='mh-alert-cell' style={{ width: '10%' }}>
              <span className={`mh-alert-status ${props.data.Estatus == 'RESOLVED' ? 'mh-status-resolved' : 'mh-status-problem'}`}>
                {props.data.Estatus}
              </span>
            </div>
            <div className='mh-alert-cell' style={{ width: '4%' }}>{props.data.tipo}</div>
            <div className='mh-alert-cell' style={{ width: '4%', fontWeight: 'bold' }}>{props.data.dependents}</div>
            <div className='mh-alert-cell' style={{ width: '5%' }}>
              <div className="mh-radio-btn" style={{ borderColor: (props.data.acknowledges_concatenados != null && props.data.acknowledges_concatenados != "") ? '#0ea5e9' : '#e2e8f0' }}>
                {(props.data.acknowledges_concatenados != null && props.data.acknowledges_concatenados != "") ? <div className='mh-radio-btn-fill' style={{ background: '#0ea5e9' }}></div> : null}
              </div>
            </div>
            <div className='mh-alert-cell' style={{ width: '5%' }}>
              <div className="mh-radio-btn" style={{ borderColor: ((props.data.ticket_id == null || props.data.ticket_id == "") && (props.data.ticket_status == null || props.data.ticket_status == "")) ? '#e2e8f0' : ((props.data.ticket_status == 'creado') ? '#10b981' : ((props.data.ticket_status == 'error') ? '#ef4444' : '#eab308')) }}>
                {((props.data.ticket_id == null || props.data.ticket_id == "") && (props.data.ticket_status == null || props.data.ticket_status == "")) ? '' : (
                  <div className='mh-radio-btn-fill' style={{ background: (props.data.ticket_status == 'creado') ? '#10b981' : ((props.data.ticket_status == 'error') ? '#ef4444' : '#eab308') }}></div>
                )}
              </div>
            </div>
            <div className='mh-alert-cell' style={{ width: '5%', color: '#64748b' }}>{(props.data.sla == null || props.data.sla == "") ? "N/A" : props.data.sla}</div>
            <div className='mh-alert-cell' style={{ width: '10%', color: '#64748b', fontSize: '11px' }}>{calcularDiferenciaTiempo(cambiarFormatoFecha(props.data.Time.slice(0, 10)), props.data.Time.slice(-8))}</div>
            <div className='mh-alert-cell' style={{ width: '6%', color: '#64748b', fontSize: '9px' }}>{props.data.Time.slice(0, 10)}</div>
            <div className='mh-alert-cell' style={{ width: '6%', color: '#64748b', fontSize: '10px', fontWeight: '600' }}>
              {(props.data.Estatus == 'RESOLVED' && props.data.recovered_at.length > 5) ? props.data.recovered_at.slice(-8) : props.data.Time.slice(-8)}
            </div>
          </div>
        ) : ''}
        <MenuAlert languaje={props.languaje} setImportModalOpen={props.setImportModalOpen} setSuveryId={props.setSuveryId} handleShowPopup={props.handleShowPopup} setSearchTerm={props.setSearchTerm} ubiActual={props.ubiActual} search_problems={props.search_problems} server={props.server} ackMessage={ackMessage} setAckMessage={setAckMessage} isOpen={menuAlertOpen} props={props} onClose={closeMenuAlert} />
      </>
    )
  } catch (error) {
    <InternalError></InternalError>
  }
}
export default RowProblem